import { configureStore } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import farmsReducer from './farms'
import vaultsReducer from './vaults'
import poolsReducer from './pools'
import zapReducer from './zap'
import multiPoolReducer from './multiPool'
import wheelReducer from './wheel'
import userCollectionsReducer from './userCollections'
import launchpadReducer from './launchpad'
import presaleReducer from './presale'
import seriesesReducer from './serieses'
import apiServicesReducer from './apiServices'
import blockReducer from './block'

import application from './application/reducer'
import user from './user/reducer'
import transactions from './transactions/reducer'
import swap from './swap/reducer'
import lists from './lists/reducer'
import multicall from './multicall/reducer'

const store = configureStore({
  devTools: process.env.NODE_ENV !== 'production',
  reducer: {
    apiServices: apiServicesReducer,
    block: blockReducer,
    farms: farmsReducer,
    vaults: vaultsReducer,
    pools: poolsReducer,
    multiPool: multiPoolReducer,
    launchpad: launchpadReducer,
    presale: presaleReducer,
    serieses: seriesesReducer,
    userCollections: userCollectionsReducer,
    zap: zapReducer,
    wheel: wheelReducer,

    // Exchange
    application,
    user,
    transactions,
    swap,
    multicall,
    lists,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

/**
 * @see https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
 */
export type AppState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()

export default store
